import Badge, { type BadgeProps } from '@ingka/badge';
import { translate } from '@repo/phrase';
import type { SignStatus } from '@repo/types/docusign';

interface Props {
    status: SignStatus;
}

export const SignaturesStatusViewStatusBadge = ({ status }: Props) => {
    let label: string;
    let color: BadgeProps['colour'];
    switch (status) {
        case 'SIGNED': {
            label = translate('docusign_signed');
            color = 'green';
            break;
        }
        case 'DECLINED': {
            label = translate('docusign_declined');
            color = 'red';
            break;
        }
        case 'EXPIRED': {
            label = translate('docusign_expired');
            color = 'red';
            break;
        }
        case 'FAILED': {
            label = translate('docusign_failed');
            color = 'red';
            break;
        }
        default: {
            label = translate('docusign_pending');
            color = 'yellow';
        }
    }

    return (
        <span data-testid={`signature-status-${status}`}>
            <Badge label={label} colour={color} />
        </span>
    );
};
